<template>
<div class="edit-business-seo">
        <div class="">
            <div class="row">
                <div class="col-md-6">
                    <div class="detailedstep__form detailedstep__horizontal mw-100">
                        <p class="detailedstep__title">Keywords</p>

                        <div class="detailedstep__input mw-100">
                            <input type="text" name="keywords" placeholder="Keywords" class="input__text" v-model="form.keywords"/>
                        </div>
                     </div>
                </div>
                <div class="col-md-6">
                    <p class="detailedstep__title" style="text-align: left;margin-top:20px">Company description</p>
                    <div class="detailedstep__input mw-100">
                        <textarea id="tiny" contenteditable="true" v-model="form.description"></textarea>
                    </div>
                </div>
            </div>
        </div>
    <div class="detailedstep__form mg-tp-45">
        <a href="#" class="button__next text-white" @click.prevent="saveData()">Save</a>
    </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';


    export default {
        props: ['description', 'keywords', 'route'],
        data(){
            return{
                form: {
                    description: '',
                    keywords: '',
                    // no_of_employees: {},
                    // referrer: ''
                },
                updateLater: false,
                editorInit: {
                    height: 500,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help'
                }
            }
        },
        methods: {
            initTinymce() {
                self = this;
               tinymce.init({
                    selector: '#tiny',
                    height:600,
                    plugins: 'link image media print code paste preview fullpage fullscreen table hr pagebreak nonbreaking anchor lists textcolor',
                    toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
                    width:'100%',
                    paste_data_images: true,
                    setup: function(editor) {
                        editor.on('init', function(e) {
                            self.updateLater = !Boolean(self.form.description);
                            console.log(self.updateLater);
                            console.log('The Editor has initialized.');
                        });
                        editor.on('change keyup', function(e) {
                            self.form.description = editor.getContent();
                        });
                    }
                });

            },
            saveData() {
                const self = this;
                axios.patch(this.route, {
                    description: self.form.description,
                    keywords: self.form.keywords,
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.success) {
                            window.location.reload(); // change to notification later
                        } else {
                            self.loading = false;
                        }
                    })
                    .catch(function (error) {
                        self.loading = false;
                    });
            },
        },
        mounted() {
         this.initTinymce();
         this.form.description = this.description;
         this.form.keywords = this.keywords;
         // this.form.referrer = this.referrer;
         // this.form.no_of_employees = this.optionsEmployees.find(x => x.id == this.number_of_employees);
        },


    }
</script>

<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
